import { useEffect, useState } from "react";
import axios from "../../../../../services/axios";
import Constants from "../../../../../constants/Index";
import { AlertModal } from "../../../../Modal/Alert/Index";
import { SimpleButtonClose } from "../../../../Modal/Contents/SimpleButtonClose/Index";
import { TitleModal } from "../../../../Modal/Contents/TitleModal/Index";
import { ButtonV2 } from "../../../../FormControlsV2";
import { UserFormV2 } from "../../../../FormsV2";
import "../styles.css";

type CreateSalterUserModalProps = {
  visible: boolean;
  onClose: () => void;
  onCreated: () => void;
};

export function CreateSalterUserModal({ visible, onClose, onCreated }: CreateSalterUserModalProps) {
  const profile = { label: "Salgador", value: 6 };
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState<{ name?: string; phone?: string; api?: string }>({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!visible) {
      setName("");
      setPhone("");
      setErrors({});
    }
  }, [visible]);

  function save() {
    const nextErrors: typeof errors = {};
    if (!name.trim()) nextErrors.name = "*Campo obrigatório não informado.";
    else if (!/^[^\s]+(\s+[^\s]+)*$/.test(name) || name.length < 3) {
      nextErrors.name = "Escreva um nome válido com no mínimo 3 letras.";
    }
    if (!phone) nextErrors.phone = "*Campo obrigatório não informado.";
    else if (phone.length !== 11) nextErrors.phone = "Telefone informado inválido!";
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    setSaving(true);
    axios.post("/users/user", [{
      name: name.trim(),
      phone,
      profile_id: 6,
      password: Constants.DEFAULT_PASSWORD,
    }])
      .then(() => {
        onCreated();
        onClose();
      })
      .catch((reason) => setErrors({
        api: reason?.response?.data?.msg || "Não foi possível cadastrar o usuário.",
      }))
      .finally(() => setSaving(false));
  }

  return (
    <AlertModal
      visible={visible}
      onCloseFunction={onClose}
      contentStyle={{
        width: "min(680px, calc(100vw - 32px))",
        height: "min(500px, calc(100vh - 32px))",
        borderRadius: 20,
        padding: 30,
      }}
    >
      <div className="salter-user-modal">
        <div className="salter-user-modal__header">
          <TitleModal>Novo usuário salgador</TitleModal>
          <SimpleButtonClose onClick={onClose} />
        </div>
        <div className="salter-user-modal__body">
          <UserFormV2
            namePrefix="new-salter"
            profile={profile}
            profiles={[profile]}
            name={name}
            phone={phone}
            profileDisabled
            profileSearchable={false}
            errors={{ name: errors.name, phone: errors.phone }}
            onProfileChange={() => {}}
            onNameChange={setName}
            onPhoneChange={setPhone}
          />
          {errors.api && <small className="ov2-field__error">{errors.api}</small>}
        </div>
        <div className="salter-user-modal__actions">
          <ButtonV2 variant="secondary" onClick={onClose} disabled={saving}>Cancelar</ButtonV2>
          <ButtonV2 onClick={save} disabled={saving}>Salvar</ButtonV2>
        </div>
      </div>
    </AlertModal>
  );
}
